import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const ClaimsFormatter = () => {
  const faqs = [
    {
      question: "Q: What does the Claims Formatter do?",
      answer:
        "A: The Claims Formatter standardizes claims by updating status identifiers, removing strikethrough and bracketed text, preserving clean claim language without underlines, and reporting any identified claim or text discrepancies directly in the output document.",
    },
    {
      question: "Q: How is Claims Formatter triggered in JUNE?",
      answer: (
        <>
          A: Users can select <strong>Claims Formatter</strong> from the menu or
          enter prompts such as <em>clean claims</em> or{" "}
          <em>claims formatting</em>.
        </>
      ),
    },
    {
      question: "Q: What type of file can be uploaded?",
      answer: "A: Only .docx claims documents are supported.",
    },
    {
      question: "Q: Why are my claims not showing up in the output?",
      answer: (
            <>
            A: Claims Formatter identifies the claims section using standard claim
            headers such as{" "}
            <strong>“What is claimed is”</strong> or{" "}
            <strong>“Listing of Claims.”</strong>{" "}
            <br />
            If the document does not include one of these headers, or if the header is
            significantly modified, the system may be unable to locate and extract the
            claims.
            </>
        )
    },
    {
      question: "Q: Does it change the claim text?",
      answer:
        "A: No. The formatter does not rewrite or alter substantive claim language. It only cleans formatting and reports observations while preserving the original text content.",
    },
    {
      question: "Q: What observations are flagged?",
      answer:
        "A: The formatter reports observations such as:\n\n" +
        "• Extra space between words or before punctuation\n" +
        "• Consecutive punctuation marks\n" +
        "• Missing required period (.) at the end of a claim or statement\n" +
        "• Extra periods remaining after strikethrough text removal\n" +
        "• Incorrect claim references (e.g., cancelled, future, non-existent, or self-referencing claims)\n" +
        "• Circular dependencies (e.g., Claim 2 depends on Claim 3, and Claim 3 depends on Claim 2)\n" +
        "• Keyword mismatches\n\n" +
        "All observations are annotated in the output document.",
    },
    {
      question: "Q: What does “Keyword mismatch” mean?",
      answer:
        "A: A keyword mismatch is reported when expected claim-structuring keywords or patterns used to determine claim relationships or structure are inconsistent or improperly used. This highlights areas that may require manual review for structural correctness.",
    },
    {
      question: "Q: Are observations automatically fixed?",
      answer:
        "A: No. Observations are reported but not auto-corrected, allowing users to review and make informed edits.",
    },
    {
      question: "Q: Does it include the full OA Shell workflow?",
      answer:
        "A: No. Only the Clean Claims functionality is included. The broader OA Shell workflow is out of scope.",
    },
    {
      question: "Q: Can I upload a last-filed response draft?",
      answer:
        "A: Yes. Claims Formatter supports both last-filed response drafts and claims-only .docx files. For more consistent results, uploading a claims-only document is recommended.",
    },
    {
      question: "Q: What happens when I upload a last-filed response draft?",
      answer: (
            <>
            A: When a last-filed response draft is uploaded, Claims Formatter extracts
            only the claims section and applies the claims formatting logic. The output
            is a <strong>new, claims-only document</strong>.
            </>
        )
    },
    {
      question: "Q: Are pharma claims files with chemical structures supported?",
      answer:
        "A: Claims files containing chemical structures or complex embedded objects (commonly found in pharma-related claims) may not always be processed successfully. For best results, we recommend uploading a text-only claims .docx file.",
    },
  ];

  return (
    <Box>
      {faqs.map((faq, i) => (
        <Accordion
          key={i}
          defaultExpanded={i === 0}
          sx={{
            backgroundColor: "#fff",
            "&.Mui-expanded": { margin: 0 },
            borderBottom: "1px solid #e0e0e0",
          }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="body2" fontWeight="bold">
              {faq.question}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography sx={{ whiteSpace: "pre-line" }}>
              {faq.answer}
            </Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};

export default ClaimsFormatter;